const ContactDetailsFactory = function ($resource) {
    return {
        retrieveContactDetails: $resource(
            __authenticationUrl__ + "rest/retrieveContactDetails",
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        )
    };
};

ContactDetailsFactory.$inject = ["$resource", "$window"];
export default ContactDetailsFactory;
